import React from 'react';
import './BookCoverPlaceholder.css';

interface BookCoverPlaceholderProps {
  title?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

/**
 * Premium placeholder dla okładki książki
 * Używany gdy książka nie ma dodanej okładki
 */
export const BookCoverPlaceholder: React.FC<BookCoverPlaceholderProps> = ({ 
  title, 
  size = 'medium',
  className = '' 
}) => {
  // Wyciągnij pierwsze litery z tytułu dla bardziej personalnego placeholdera
  const getInitials = (text?: string): string => {
    if (!text) return '📚';
    
    const words = text.trim().split(' ');
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[1][0]).toUpperCase();
  };

  const initials = getInitials(title);
  const isEmoji = initials === '📚';

  return (
    <div className={`book-cover-placeholder book-cover-placeholder--${size} ${className}`}>
      <div className="book-cover-placeholder__bg">
        {/* Gradient orb dla efektu depth */}
        <div className="book-cover-placeholder__orb book-cover-placeholder__orb--1"></div>
        <div className="book-cover-placeholder__orb book-cover-placeholder__orb--2"></div>
      </div>
      
      <div className="book-cover-placeholder__content">
        {isEmoji ? (
          <div className="book-cover-placeholder__icon">
            📚
          </div>
        ) : (
          <div className="book-cover-placeholder__initials">
            {initials}
          </div>
        )}
        
        {/* Dekoracyjny element */}
        <div className="book-cover-placeholder__accent"></div>
      </div>
    </div>
  );
};


